<template>
  <div class="dial-table-container">
    <div class="left-table" v-if="dialInfo.groups">
      <div class="left-table-container">
        <div class="row" v-for="(row, index) in dialInfo.groups" :key="`row-${index}`">
          <div class="header" v-if="row.label">{{ row.label }}</div>
          <div class="data" v-for="(properties, index) in row.properties" :key="`properties-${index}`">
            {{ properties.data }}
          </div>
          <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
            {{ data.data }}
          </div>
        </div>
      </div>
    </div>
    <div class="left-table" v-if="dialInfo.results">
      <div class="left-table-container">
        <div class="row" v-for="(row, index) in dialInfo.results" :key="`row-${index}`">
          <div class="header" v-if="row.label">{{ row.label }}</div>
          <div class="data" v-for="(properties, index) in row.properties" :key="`properties-${index}`">
            {{ properties.data }}
          </div>
          <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
            {{ data.data }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FG',
  components: {},
  props: {
    dialInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.left-table {
  margin-right: 10px;
}
</style>
